import { useMemberDetails } from "@/helpers/member-details.js";
import { useProgressHelper } from "@/helpers/progress-helper.js";
import { baseWizardUrl } from "@/helpers/wizard-helper.js";
import CreateAccount from "@/views/CreateAccount/CreateAccount.vue";
import Membership from "@/views/Membership/Membership.vue";
import ContactDetails from "@/views/Membership/Sections/ContactDetails.vue";
import DiversityDetails from "@/views/Membership/Sections/DiversityDetails.vue";
import EducationDetails from "@/views/Membership/Sections/EducationDetails.vue";
import GettingStarted from "@/views/Membership/Sections/GettingStarted.vue";
import Payment from "@/views/Membership/Sections/Payment.vue";
import Review from "@/views/Membership/Sections/Review.vue";
import WorkDetails from "@/views/Membership/Sections/WorkDetails.vue";
import SelectMembership from "@/views/Membership/SelectMembership.vue";
import Renewal from "@/views/Renewal/Renewal.vue";
import ThankYou from "@/views/ThankYou/ThankYou.vue";
import CheckVerification from "@/views/VerifyAccount/Check.vue";
import VerifyAccount from "@/views/VerifyAccount/VerifyAccount.vue";
import APRA from "@/views/Wizard/Sections/APRA.vue";
import WizardEntry from "@/views/Wizard/Sections/Entry.vue";
import International from "@/views/Wizard/Sections/International.vue";
import NoMembership from "@/views/Wizard/Sections/NoMembership.vue";
import Ordinary from "@/views/Wizard/Sections/Ordinary.vue";
import RadiographicAssistant from "@/views/Wizard/Sections/RadiographicAssistant.vue";
import Student from "@/views/Wizard/Sections/Student.vue";
import Study from "@/views/Wizard/Sections/Study.vue";
import UKResident from "@/views/Wizard/Sections/UKResident.vue";
import WorkStudyUK from "@/views/Wizard/Sections/WorkStudyUK.vue";
import Wizard from "@/views/Wizard/Wizard.vue";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
  },
  {
    path: "/register/new-member",
    name: "NewMember",
    component: SelectMembership,
  },
  {
    path: "/register/renewal",
    name: "Renewal",
    component: Renewal,
  },
  {
    path: baseWizardUrl,
    component: Wizard,
    children: [
      {
        name: "Wizard",
        path: "",
        component: WizardEntry,
        meta: {
          progressStep: 0,
        },
      },
      {
        path: "apra",
        component: APRA,
        meta: {
          progressStep: 0,
        },
      },
      {
        path: "international",
        component: International,
        meta: {
          progressStep: 0,
        },
      },
      {
        path: "student",
        component: Student,
        meta: {
          progressStep: 0,
        },
      },
      {
        path: "ordinary",
        component: Ordinary,
        meta: {
          progressStep: 0,
        },
      },
      {
        path: "uk-resident",
        component: UKResident,
        meta: {
          progressStep: 0,
        },
      },
      {
        path: "work-study-uk",
        component: WorkStudyUK,
        meta: {
          progressStep: 0,
        },
      },
      {
        path: "radiographic-assistant",
        component: RadiographicAssistant,
        meta: {
          progressStep: 0,
        },
      },
      {
        path: "study",
        component: Study,
        meta: {
          progressStep: 0,
        },
      },
      {
        path: "no-membership",
        component: NoMembership,
        meta: {
          progressStep: 0,
        },
      },
    ],
  },
  {
    path: "/register/membership/",
    name: "Membership",
    component: Membership,
    redirect: "/register/membership/getting-started",
    children: [
      {
        name: "Getting Started",
        path: "getting-started",
        component: GettingStarted,
        meta: {
          progressStep: -1,
        },
      },
      {
        name: "Contact Details",
        path: "contact-details",
        component: ContactDetails,
        props: (r) => ({ currentPage: Number(r.query.currentPage || "0") }),
        meta: {
          progressStep: 0,
        },
      },
      {
        path: "work-details",
        name: "Work Details",
        component: WorkDetails,
        props: (r) => ({ currentPage: Number(r.query.currentPage || "0") }),
        meta: {
          progressStep: 3,
        },
      },
      {
        path: "education-details",
        name: "Place of Study",
        component: EducationDetails,
        meta: {
          progressStep: 4,
        },
      },
      {
        path: "diversity-details",
        name: "Diversity Details",
        component: DiversityDetails,
        meta: {
          progressStep: 5,
        },
      },
      {
        path: "review",
        name: "Review",
        component: Review,
        meta: {
          progressStep: 6,
        },
      },
      {
        path: "payment",
        component: Payment,
        meta: {
          progressStep: 7,
        },
      },
    ],
  },
  {
    path: "/register/create-account",
    name: "CreateAccount",
    component: CreateAccount,
    meta: {
      progressStep: 0,
    },
  },
  {
    path: "/register/verify-account",
    name: "VerifyAccount",
    component: VerifyAccount,
    meta: {
      progressStep: 1,
    },
  },
  {
    path: "/register/check-verification",
    name: "CheckVerification",
    component: CheckVerification,
    meta: {
      progressStep: 1,
    },
  },
  {
    path: "/register/thank-you",
    name: "ThankYou",
    component: ThankYou,
    meta: {
      progressStep: 7,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, _, next) => {
  //Have to explicitly check undefined here as it misses validation in some cases if not
  if (to.meta.progressStep !== undefined) {
    const { setProgressStep } = useProgressHelper();
    let { progressStep } = to.meta;
    const { isVerified } = useMemberDetails();

    if (isVerified.value && progressStep === 0) progressStep = 2;

    setProgressStep(progressStep);
    next();
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
